module.exports = __webpack_public_path__ + "img/img7.bd259306.png";